import React from 'react';
import { StyleSheet, View } from 'react-native';

import { LoadingPlaceholder, theme } from '@sg/garnish';

import { GiftCardConfirmationContainer } from '../GiftCardConfirmationContainer';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardConfirmationLoadingPlaceholder = (props: Props) => {
  const { isModal } = props;

  return (
    <GiftCardConfirmationContainer isModal={isModal}>
      <View style={styles.container}>
        <LoadingPlaceholder
          style={styles.loadingContainer}
          rows={3}
          rowHeight={[48, 148, 400]}
          gridGap={theme.spacing['6']}
          palette="cream"
        />
      </View>
    </GiftCardConfirmationContainer>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 400,
    alignSelf: 'center',
  },
  loadingContainer: {
    width: '100%',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isModal: boolean;
};
